module.exports = __webpack_public_path__ + "static/media/Cloud01.526fb903.svg";